import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

const BackModal = ({
  isEdit,
  spaceId,
  ...props
}) => {
  return (
    <BootstrapModal
      {...props}
      header={
        <div>
          <h3>
            { !isEdit ?
              <FormattedMessage id="hosting.back_modal.back_confirmation_message" defaultMessage="Are you sure you want to go back?"/> :
              <FormattedMessage id="hosting.back_modal.cancel_confirmation_message" defaultMessage="Are you sure you want to cancel?"/>
            }
          </h3>
          <div>
            <FormattedMessage id="hosting.back_modal.change_not_saved_message" defaultMessage="Your changes will not be saved."/>
          </div>
        </div>
      }
      modalSize="sm-size"
      modalClass="delete-listing-modal"
      body={
        <div className="text-center">
          <div>
            <a
              href={!isEdit ?
                `/your-space/${spaceId}/photos` :
                '/calendar'
              }
              className="btn btn-block btn-primary"
            >
              {!isEdit ? <FormattedMessage id="hosting.back_modal.back_link_text" defaultMessage="Go back"/> : <FormattedMessage id="hosting.back_modal.cancel_link_text" defaultMessage="Cancel"/>}
            </a>
          </div>
          <div className="margin-md-top">
            <button
              className="btn btn-link remove-click-styling"
              onClick={() => props.toggleModal('') }
            >
              { !isEdit ? <FormattedMessage id="hosting.back_modal.button_text_dont_go_back" defaultMessage="I don't want to go back"/> : <FormattedMessage id="hosting.back_modal.button_text_dont_cancel" defaultMessage="I don't want to go cancel"/> }
            </button>
          </div>
        </div>
      }
    />
  );
};

BackModal.propTypes = {
  isEdit: PropTypes.bool,
  toggleModal: PropTypes.func,
  spaceId: PropTypes.string
};

export default BackModal;
